/**
 * @desc 对象管理--线索池管理
 * @author zl zhaolun@qfei.cn
 * @date 2023年12月06日09:56:20
 */
export default {
  线索池设置: 'Lead pool setting',
  保有量设置: 'Inventory setting',
  布局设置: 'Layout setting',
  线索池列表: 'Lead pool list',
  线索池名称: 'Lead pool name',
  线索池成员: 'Lead pool members',
  搜索线索池名称: 'Please input pool name to search',
  一般规则设置: 'General rule settings',
  保有量上限: 'The maximum quantity retained',
  可设置每个人可保有的线索量上限: 'You can set an upper limit on the number of clues each person can keep',
  '不在特殊规则中的人员，根据一般规则保有量上限生效': 'Persons not included in the special rules shall be subject to the retention cap of the general rules',
  '已作废、已转化的线索不计入保有量': 'Obsolete or converted clues are not counted in the inventory',
  请输入保有量上限: 'Please enter the maximum number of holdings',
  特殊规则设置: 'Special rule settings',
  每个员工仅可以设置一个特殊规则: 'Each employee can set only one special rule',
  '员工被设置特殊规则时，优先使用特殊规则': 'When special rules are set on employees, special rules are preferred',
  添加特殊规则: 'Add a special rule',
  编辑特殊规则: 'Edit a special rule',
  编辑: 'Edit',
  删除: 'Delete',
  选择成员: 'Select member',
  请选择成员: 'Please select a member',
  '部门/员工': 'Department/staff',
  操作: 'Operation',
  新增线索池: 'Pool Add',
  列表布局: 'List layout',
  请选择列表布局: 'Please select the list layout',
  新增布局: 'Added layout',
  请选择新增布局: 'Please select the new layout',
  编辑布局: 'Edit layout',
  请选择编辑布局: 'Please select edit layout',
  详情页布局: 'Details layout',
  请选择详情页布局: 'Please select the details page layout',
  编辑线索池: 'Edit pool',
  添加线索池: 'Add pool',
  基础设置: 'Basic settings',
  请输入线索池名称: 'Please enter the pool name',
  请选择管理员: 'Please select an administrator',
  '管理员可以有多个人，管理员可分配线索，成员只可给自己领取线索': 'Administrators can have multiple people, administrators can allocate clues, members can only give themselves clues',
  请选择线索池成员: 'Please select the lead pool member',
  '领取/分配规则': 'Retrieval rules',
  成员领取规则: 'Member retrieval rules',
  '成员可见可领取，管理员可分配': 'Members can see and retrieve clues, administrators can allocate clues',
  成员可自己领取线索池中所有未分配线索: 'Members can retrieve all unallocated clues in the lead pool',
  '成员可见不可领取，管理员可分配': 'Members can see but cannot retrieve clues, administrators can allocate clues',
  '成员不可自己领取线索池中线索，只能等待自动分配或管理员手工分配': 'Members cannot retrieve clues in the lead pool themselves, they can only wait for automatic allocation or be allocated by administrators',
  提醒设置: 'Notification settings',
  '线索被成员手工领取后，通过消息卡片提醒线索池管理员': 'Clues retrieved by members manually are notified by message cards to the lead pool administrator',
  '线索被管理员分配后，通过消息卡片提醒线索负责人': 'Clues allocated by administrators are notified by message cards to the lead responsible person',
  自动分配规则: 'Automatic allocation rules',
  '开启后必须添加至少一个自动分配规则支持自动将池中线索分给人，也支持分给某个池': 'Opening this function requires at least one automatic allocation rule to support automatic distribution of clues to people and to a pool',
  '自动分配规则于每晚00:00自动执行，如存在存量未领取线索，将按规则自动分配': 'Automatic allocation rules are executed every hour at 00:00, and if there are unretrieved clues in the pool, they will be automatically distributed according to the rules',
  执行顺序: 'Execution order',
  规则名称: 'Rule name',
  规则类型: 'Rule type',
  池到人: 'Pool to person',
  池到池: 'Pool to pool',
  添加分配规则: 'Add allocation rule',
  自动回收规则: 'Automatic recycling rules',
  开启后必须添加至少一个自动收回规则: 'Opening this function requires at least one automatic recycling rule',
  '自动收回规则每小时执行一次，如存在满足收回规则的线索，将自动收回': 'The automatic retrieval rule is executed once every hour. If there are clues that meet the retrieval rule, it will be automatically retrieved',
  添加回收规则: 'Add recycling rule',
  规则名称已存在: 'Rule name already exists',
  编辑分配规则: 'Edit allocation rule',
  新建分配规则: 'New allocation rule',
  池到人分配规则: 'Pool to person allocation rule',
  将线索自动分配给指定的人员: 'Clues are automatically allocated to the specified person',
  池到池分配规则: 'Pool to pool allocation rule',
  将线索自动分配给指定的线索池: 'Clues are automatically allocated to the specified lead pool',
  请输入规则名称: 'Please enter the rule name',
  数据范围: 'Data range',
  所有未领取线索: 'All unretrieved clues',
  自定义数据范围: 'Customized data range',
  '如自定义数据范围，则只有满足数据条件的线索才执行此自动分配规则，未满足条件的线索不自动分配': 'If you customize the data range, only clues that satisfy the data conditions will be executed by this automatic allocation rule. Clues that do not satisfy the conditions will not be automatically distributed',
  成员范围: 'Member range',
  线索池所有成员: 'Clue pool members',
  指定成员: 'Member',
  编辑成员: 'Edit member',
  分配方式: 'Allocation method',
  按成员姓名首字母排序轮流分配: "Use the first letter of the member's name to sort and allocate members in turn",
  '按成员线索保有量，优先分配给线索量最少的成员': 'Use the number of clues held by each member to sort and allocate members in turn',
  分配到: 'Allocated to',
  请选择线索池: 'Please select the lead pool',
  触发时机: 'Trigger time',
  全选: 'Check all',
  线索池新增线索: 'Clue pool new clues',
  线索池导入线索: 'Clue pool import',
  销售退回线索: 'Sale return clues',
  自动收回线索: 'Automatic recycling clues',
  转移到线索池: 'Transfer to lead pool',
  自动分配到线索池: 'Auto allocation to lead pool',
  '线索自动分配后，通过消息卡片提醒线索跟进人': 'Clues automatically allocated are notified by message cards to the lead follow-up person',
  编辑收回规则: 'Edit recycling rule',
  新建收回规则: 'New recycling rule',
  请填写收回规则: 'Please fill in the recycling rule',
  收回规则: 'Recycling rule',
  '1、已转化的线索不参与自动收回': '1、Already converted clues do not participate in automatic recycling',
  '2、标准规则指系统已预置一些定义好的规则，逻辑如下：': '2、Standard rules are preset by the system, and the logic is as follows:',
  '未拨打电话：当前日期-最新通话记录的创建日期＞XX天XX小时': 'Uncalled: Current date - Latest call record creation date > XX days XX hours',
  '未添加动态记录：当前日期-最新动态记录的创建日期＞XX天XX小时': 'Unadded follow-up record: Current date - Latest follow-up record creation date > XX days XX hours',
  '未添加日程：当前日期-最新日程的创建日期＞XX天XX小时': 'Unadded schedule: Current date - Latest schedule creation date > XX days XX hours',
  '未编辑线索：当前日期-线索的最后更新日期＞XX天XX小时': "Unedited clue: Current date - Clue's last update date > XX days XX hours",
  '未添加联系人：当前日期-最新的联系人添加日期＞XX天XX小时': 'Unadded contact: Current date - Latest contact addition date > XX days XX hours',
  '未添加协作人：当前日期-最新的协作人添加日期＞XX天XX小时': 'Unadded cooperation: Current date - Latest cooperation addition date > XX days XX hours',
  '未转化线索：当前日期-线索的最新分配日期＞XX天XX小时': "Unconverted clue: Current date - Clue's latest allocation date > XX days XX hours",
  获得线索: 'Get clues',
  天数: 'Days',
  天: 'Days',
  小时数: 'Hours',
  小时内: 'Hours',
  小时: 'Hours',
  如果: 'If',
  请选择: 'Please select',
  线索回收: 'Clue recycling',
  标准规则: 'Standard rules',
  自定义规则: 'Customized rules',
  线索回收前: 'Clue recycling before',
  通过消息卡片提醒线索负责人: 'Through message cards to notify the lead responsible person',
  '线索自动收回后，通过消息卡片提醒线索负责人': 'Clues automatically recycled are notified by message cards to the lead responsible person',
  '线索自动收回后，通过消息卡片提醒收回池管理员': 'Clues automatically recycled are notified by message cards to the recycling pool administrator'
};
